import React from 'react'
import classNames from 'classnames'

import CustomLink from 'components/Link/CustomLink'

import styles from './Sitemap.module.scss'

import { SitemapLink } from 'utils/sitemap'

interface SitemapSectionProps {
  heading?: string
  links: SitemapLink[]
  isIndex?: boolean
}

const SitemapSection = ({
  heading,
  links,
  isIndex = false,
}: SitemapSectionProps) => {
  return (
    <>
      {heading && <header>{heading}</header>}
      <article className={classNames({ [styles.twoColumnMobile]: isIndex })}>
        {links.map((link: SitemapLink) => {
          const href = isIndex ? link.href : `/sitemap${link.href}`
          return (
            <CustomLink
              className={styles.link}
              href={href}
              key={`${link.name}-link`}
              prefetch={false}
            >
              {link.name}
            </CustomLink>
          )
        })}
      </article>
    </>
  )
}

export default SitemapSection
